module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "page-access"
  }, [_c('HeroPages', {
    attrs: {
      "props": _vm.props.acf
    }
  }), _vm._m(0)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "access_wrap"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Thank You")]), _c('p', [_vm._v("Thank you for your message. It has been sent. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-895b0998","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 591
// module chunks = 1